<sdps-modal-beta (close)="onModalClose($event)" [attr.sdps-title]="title" id="editing-restricted-modal">
  <div slot="modal-body">
    <div class="sdps-text-body">{{textBody}}</div>
  </div>
  <div slot="modal-footer">
    <button (click)="onOkayClick()" type="button"
      class="sdps-button sdps-button--small sdps-button--primary">Okay</button>
  </div>
</sdps-modal-beta>